<template>
    <div>
        <slot name="header">
            <h2 class="mb-0">{{ $l10n.__('Lecture du fichier CSV') }}</h2>
            <p class="fs-3 gray-80 mt-2 mb-0">
                {{
                    $l10n.__(
                        'Nous avons besoin de vous pour lire et interpréter les différentes colonnes et lignes de votre document.',
                    )
                }}
            </p>
            <p class="fs-3 gray-80 mt-0">
                {{
                    $l10n.__(
                        'Nous enregistrerons ces informations pour faciliter vos futurs imports.',
                    )
                }}
            </p>
        </slot>
        <div>
            <slot name="content"></slot>
        </div>
        <div class="mt-4">
            <div class="aright">
                <slot name="footer">
                    <CompassButton
                        :label="$t.__('common.labels.previous')"
                        type="secondary"
                        :disabled="loading"
                        @click="$emit('previous')"
                        v-if="previousStep"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.continue')"
                        type="primary"
                        :disabled="loading"
                        @click="$emit('next')"
                        v-if="nextStep"
                    />
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        previousStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        nextStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
};
</script>

<style scoped></style>
